import type { Tealium } from 'src/types/appState';

import {
  EVENT_VIEW_CONCIERGE,
  EVENT_VIEW_GUARANTEED_HIRE,
  EVENT_VIEW_PREMIUM_PLUS,
} from '../constants';

const getPurchaseType = (hirerType: string) =>
  hirerType.search('repeat') !== -1;

export const conciergeEventName = EVENT_VIEW_CONCIERGE;
export const guaranteedHireEventName = EVENT_VIEW_GUARANTEED_HIRE;
export const premiumPlusEventName = EVENT_VIEW_PREMIUM_PLUS;

export default (tealium: Tealium) => {
  const {
    cajaPayType,
    cajaWorkType,
    emailAddressVerified,
    hirerAdPurchaser,
    jobAdClassification,
    jobAdSubClassification,
    roleTitle,
    salaryRangeSelected,
    testingId,
    previousPageName,
    productSetId,
  } = tealium;
  return {
    actionOrigin: 'caja',
    adProductSetId: productSetId,
    adSalaryRangeSelected: salaryRangeSelected,
    isEcajaStart: !previousPageName,
    isEmailUnverified: !emailAddressVerified,
    isHirerRepeatAdPurchaser: getPurchaseType(hirerAdPurchaser),
    jobSalaryType: cajaPayType,
    jobWorkType: cajaWorkType,
    jobClassification: jobAdClassification,
    jobSubClassification: jobAdSubClassification,
    jobTitle: roleTitle,
    testingId,
  };
};
